export default __webpack_public_path__ + "static/media/pickupBlue.58c46ea8.svg";